import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function RepeatedPYQChemTopics() {
  return (
    <>

      <AllSubjectTopics subject="chemistry" type="repeatedpyq" />


    </>
  );
}

export default RepeatedPYQChemTopics;